module.exports = __webpack_public_path__ + "static/media/veryvell_4.4ddcd321.png";